import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    logoSection: {
        margin: '40px',
    },
    form: {
        width: '75%',
        '& .MuiFormControl-root': {
            marginBottom: theme.spacing(1)
        },
        marginBottom: theme.spacing(1)
    },
    formControlContainer: {
        width: '75%',
        marginBottom: theme.spacing(2),
    },
    linkContainer: {
        marginBottom: theme.spacing(4),
        '& a': {
            color: theme.palette.secondary.main
        },
        justifyContent: 'space-between'
    },
    button: {
        width: '100%',
        marginBottom: theme.spacing(1),
    },
    footer: {
        width: '100%',
    },
    buttonProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

export default useStyles;
